// MF-566 — Card 'score-list': one row per test — label, score and a pill with its band
// (e.g. "Maths 120 · 115-124"). Rows come as { label, value, band }.
import { Box, Typography } from '@mui/material'
import { SUMMARY_PALETTE } from '../../../Dashboard/StudentSummary/summary.palette'
import { fmtValue } from '../boardTheme'

const ScoreListCard = ({ data }) => {
  const rows = data?.rows || []
  const decimals = data?.meta?.card?.options?.decimals || 0
  return (
    <Box sx={{ height: '100%', overflow: 'auto' }}>
      {rows.map((r, i) => (
        <Box
          key={r.label}
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: 1,
            py: 1.25,
            borderBottom: i < rows.length - 1 ? `1px solid ${SUMMARY_PALETTE.grid}` : 'none'
          }}
        >
          <Box sx={{ minWidth: 0 }}>
            <Typography sx={{ fontSize: 14, color: SUMMARY_PALETTE.ink }}>{r.label}</Typography>
            <Typography sx={{ fontSize: 18, fontWeight: 600, color: SUMMARY_PALETTE.good }}>
              {fmtValue(r.value, decimals)}
            </Typography>
          </Box>
          {r.band ? (
            <Box
              sx={{
                px: 1.5,
                py: 0.5,
                borderRadius: '12px',
                fontSize: 12,
                fontWeight: 600,
                color: SUMMARY_PALETTE.ink,
                bgcolor: '#e3ebf6',
                whiteSpace: 'nowrap'
              }}
            >
              {r.band}
            </Box>
          ) : null}
        </Box>
      ))}
    </Box>
  )
}

export default ScoreListCard
